<template>
  <!--<div>-->
    <div class="page-content">
      <!-- コンテンツ情報表示前 -->
      <div class="inner" v-if="!contents" />
      <!-- コンテンツ情報あり -->
      <div class="inner" v-else-if="0 < contents.length">
        <div class="card-contents" v-for="detail in contents" :key="detail.contentid">
          <div class="flexcenternowrap" @click="showPurchasedDetail(detail)">
            <div class="cover-image"><img :src="getContentsThumbnailPath(detail.contentid, showScreen)" :alt="detail.content_name"></div>
            <div class="detail-content">
              <div class="flexbetween">
                <div class="content-name font28" v-html="getContentName(detail)" />
              </div>

              <div class="content-button">
                <button><img src="static/images/icon/png/ar_r_circle_gray.png"></button>
              </div>
            </div><!-- detail-content -->
          </div><!-- flexcenter -->
        </div><!-- card-contents v-for(contents) -->
      </div><!-- inner -->
      <!-- コンテンツ情報なし -->
      <div v-else class="inner">
        <div class="no-contents">
          <div class="align-center">
            <p class="font24">利用可能なコンテンツがありません</p>
          </div>
        </div><!-- no-contents -->
      </div><!-- inner -->
    </div><!-- page-content -->
  <!-- </div> -->
</template>

<script>
import common from '@/mixin/common';
import http from '@/mixin/http';
import * as constants from '@/mixin/constants';

export default {
  name: 'AuPortalList',
  data: function () {
    return {
      contents: null,
      showScreen: 'PortalList',
    }
  },
  mixins: [
    common,
    http,
  ],
  created: function () {
    this.log("AuPortalList start created");
  },
  mounted: async function () {
    this.log("AuPortalList start mounted");

    if (!await storage_wrapper.getRsAccessKey()) {
      // アクセスキーがない場合、キャリア版利用開始画面へ遷移
      this.$router.replace({ name: "CarrierActivation" });
      return;
    }

    // コンテンツ一覧情報を取得し画面に設定する
    this.setContents();
  },
  methods: {
    /**
     * コンテンツ一覧情報を取得し画面に設定する
     */
    setContents: function () {
      var self = this;
      this.log("AuPortalList start setContents");
      this.contents = null;

      // コンテンツ情報一覧取得APIを実行
      this.getContentList().then(function (response) {
        self.log("AuPortalList getContentList result_code: " + response.result_code);
        switch (response.result_code) {
          case 'OK':
            self.contents = [];
            var push = Array.prototype.push;
            for (var category of response.categories) {
              push.apply(self.contents, category.contents.filter(function (content) { return self.isVisibleContent(content); }));
            }
            break;
          default:
            self.contents = [];
            break;
        }
      }).catch(function (err) {
        self.log("AuPortalList setContents error");
        self.contents = [];
      });
    },
    /**
     * コンテンツを画面に表示するか否かを返す
     *
     * @param {Object} content コンテンツ情報
     * @return {Boolean} true：表示する, false：表示しない
     */
    isVisibleContent: function (content) {
      return constants.CONTENTS_AU_ANDROID.some(function (au) { return content.contentid == au; });
    },
    /**
     * コンテンツ詳細画面を表示する
     */
    showPurchasedDetail: function(detail) {
      this.log("AuPortalList start showPurchasedDetail");

      if(detail.contentid == constants.CONTENTS_ID_PRIVATE1) {
        this.log("AuPortalList showPurchasedDetail: PRIVATE1");
        if(window.Phone.IsPremium() == '0') {
          // プレミアム会員ではない場合
          this.log("AuPortalList showPurchasedDetail is not premium");
          window.Phone.StartBrowser('https://pass.auone.jp/gate/allocate/');
          return;
        }
      }

      this.$emit('changeView', 'PurchasedDetail', detail)
    },
    /**
     * コンテンツ名を取得
     */
    getContentName: function(detail) {
      var name = detail.content_name;
      if(detail.contentid == constants.CONTENTS_ID_PRIVATE1) {
        name = constants.AU_PRIVATE1_CONTENTS_NAME;
      }

      return name;
    }
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/style/common';
@import 'src/assets/style/study_list';
</style>



// WEBPACK FOOTER //
// AuPortalList.vue?7fa12abd